<div class="w-100 h-100">
  <article fxLayout="column" class="mat-elevation-z1">
    <header class="px-2" [ngClass]=AppConfig.theme>
      <div fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="grow" class="my-2 ml-2">
          <a class="color-white d-inline-block txt-deco-none font-weight-normal"
             [routerLink]="[lecture.$key, 'lessons']">
            <mat-icon *ngIf="!lecture.public" class="lock-icon" >lock</mat-icon>
            {{ lecture.name }}
          </a>
        </div>
        <div fxFlex>
          <button mat-icon-button [matMenuTriggerFor]="appMenu" *appAuthorize="lecture.owner">
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
      </div>
    </header>
    <app-lesson-list fxFlexFill [lecture]="lecture" [lessons]="lessonsObservable | async"></app-lesson-list>
    <app-lesson-add-button [lecture]="lecture" *appAuthorize="lecture.owner">
      <button mat-button class="text-left w-100">학습 목표 생성</button>
    </app-lesson-add-button>
  </article>
  <mat-menu #appMenu="matMenu">
    <app-lecture-edit-button [lecture]="lecture" *appAuthorize="lecture.owner">
      <button mat-menu-item>강의 편집</button>
    </app-lecture-edit-button>
    <app-lecture-remove-button [course]="course" [lecture]="lecture" *appAuthorize="lecture.owner">
      <button mat-menu-item>강의 삭제</button>
    </app-lecture-remove-button>
  </mat-menu>
</div>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture/lecture.component.html